// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__NLVHt","emails":"CreateEditClinics_emails__vWUab","emailTagLabel":"CreateEditClinics_emailTagLabel__2iGqD"};